import { render, staticRenderFns } from "./TogglePageItemsButton.vue?vue&type=template&id=534a2376"
import script from "./TogglePageItemsButton.vue?vue&type=script&lang=js"
export * from "./TogglePageItemsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports